import React from 'react'

const NoResultContent = (props) => {
    const { message } = props;
    return (
        <>
            {message &&
                <div className='alert alert-info' role="alert">
                    <span className='w-100 bs5 d-block'><div className='text-start' dangerouslySetInnerHTML={{ __html: message }} /></span>
                </div>
            }
        </>
    )
}

export default NoResultContent